export default {
  h1: {
    fontSize: 40,
    fontFamily: 'Spartan_800ExtraBold',
  },
  h2: {
    fontSize: 32,
    fontFamily: 'Spartan_500Medium',
  },
  h3: {
    fontSize: 24,
    fontFamily: 'Spartan_500Medium',
  },
  h4: {
    fontSize: 20,
    fontFamily: 'Spartan_500Medium',
  },
  h5: {
    fontSize: 16,
    fontFamily: 'Spartan_700Bold',
  },
  label: {
    fontSize: 14,
    fontFamily: 'Spartan_700Bold',
  },
  p: {
    fontSize: 15,
    fontFamily: 'Spartan_500Medium',
  },
  mobile : {
    h1 : {
      fontSize: 32,
      fontFamily: 'Spartan_800ExtraBold',
    },
    h2: {
      fontSize: 24,
      fontFamily: 'Spartan_500Medium',
    },
  }
};
